// extracted by mini-css-extract-plugin
export default {"participantsStats":"Jfi2WF8bJsMHakaIvvOC","noMarginBottom":"i4AkP0ONxezBtPSJxR1_"};